import { defineComponent as _defineComponent } from 'vue'
interface PropsType {
  size?: string
  type?: 'primary' | 'text'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    size: { default: '20px' },
    type: { default: 'text' }
  },
  setup(__props: any) {

const props = __props as { size: string, type: 'primary' | 'text' }



const styleObj = {
  width: props.size,
  height: props.size,
  backgroundColor: props.type == 'primary' ? '#18a8c7' : 'transparent',
  color: props.type == 'primary' ? '#fff' : 'rgba(0,0,0,.9)',
  borderColor: props.type == 'primary' ? '' : 'transparent',
  borderWidth: props.type == 'primary' ? '0' : '2px',
}

return { __sfc: true,props, styleObj }
}

})